import { configureStore } from "@reduxjs/toolkit";
import appReducer from "../slices/appSlice";
import cruiesReducer from "../slices/cruiesSlice";

export const makeStore = () => {
	return configureStore({
		reducer: {
			app: appReducer,
			cruies:cruiesReducer,
		},
		devTools: process.env.NEXT_PUBLIC_APP_ENV !== "production.",
	});
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
